import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import { Link, withRouter } from "react-router-dom"
import "components/style.scss"
import {
  getBusinessUnits,
  getCategories,
  getEvents,
  selectEvent,
  selectAllEvents,
  resetEventsSelection,
  setEventsSortOptions,
  changeEventPublishField,
  openPublishNotificationModal,
  openDeleteEventModal,
  handleDeleteEvent,
  openEventBulkDeleteModal,
  handleEventBulkDelete,
  getClientConfig,
  hideExperiencesErrorModal,
  hidePublishNotificationModal,
  hideDeleteEventModal,
  hideEventBulkDeleteModal,
  openExpCloneConfirmationModal,
  hideExpCloneConfirmationModal,
  cloneExperience,
} from "store/actions"
import { prepareData } from "./utils"
import { AddButton, SaveButton } from "components/Buttons"
import { ActionsDropdown } from "components/Dropdowns"
import { URL_PATHS } from "constants/index"
import experiencesListColumns from "./ExperiencesTable/experiencesListColumns"
import ExperiencesTable from "./ExperiencesTable/experiencesTable"
import HeaderLine from "./headerLine"
import ModalComponent from "components/Modals"
import BulkPublishModal from "./bulkPublishModal"
import BulkUnpublishModal from "./bulkUnpublishModal"
import ExpTableWithCategories from "./ExperiencesTable/expTableWithCategories"
import PublishNotificationModal from "./ExperiencesTable/publishNotificationModal"
import EventBulkDeleteModal from "./eventBulkDeleteModal"
import DeleteEventModal from "./deleteEventModal"
import CloneExperienceModal from "./cloneExperienceModal"
const Experiences = ({
  getCategories,
  getEvents,
  categories,
  events,
  getBusinessUnits,
  selectAllEvents,
  resetEventsSelection,
  setEventsSortOptions,
  eventsSortOptions,
  clientConfig,
  changeEventPublishField,
  vendorId,
  openPublishNotificationModal,
  openDeleteEventModal,
  handleDeleteEvent,
  openEventBulkDeleteModal,
  handleEventBulkDelete,
  authUser,
  getClientConfig,
  errorMessage,
  errorModalIsOpen,
  hideExperiencesErrorModal,
  isPublishNotificationModalOpen,
  isDeleteEventModalOpen,
  isEventBulkDeleteModalOpen,
  hidePublishNotificationModal,
  hideDeleteEventModal,
  hideEventBulkDeleteModal,
  cloneExpModalIsOpen,
  openExpCloneConfirmationModal,
  hideExpCloneConfirmationModal,
  cloneExperience,
  history,
  loading,
}) => {
  const [rowSelection, setRowSelection] = useState({})
  const [bulkPublishModalIsOpen, setBulkPublishModalIsOpen] = useState(false)
  const [bulkUnpublishModalIsOpen, setBulkUnpublishModalIsOpen] =
    useState(false)
  const [tableData, setTableData] = useState([])

  useEffect(() => {
    if (!!clientConfig && events && categories) {
      let data = []
      if (clientConfig.categorize_experiences) {
        data = prepareData(events, categories).sort((a, b) => a.order - b.order)
      } else {
        data = events
      }
      setTableData(data)
    }
  }, [clientConfig, events, categories])

  const bulkActions = [
    {
      name: "Publish",
      onClick: () => setBulkPublishModalIsOpen(true),
      icon: "mdi mdi-publish",
      isAvailable: Object.keys(rowSelection).length > 0,
    },
    {
      name: "Unpublish",
      onClick: () => setBulkUnpublishModalIsOpen(true),
      icon: "bx bx-grid-alt",
      isAvailable: Object.keys(rowSelection).length > 0,
    },
    {
      name: "Delete",
      onClick: openEventBulkDeleteModal,
      icon: "bx bx-trash",
      isAvailable: Object.keys(rowSelection).length > 0,
    },
  ]

  useEffect(() => {
    if (authUser.business_units) {
      getEvents({
        ...eventsSortOptions,
        business_unit_id: authUser.business_units[0].id,
      })
    } else {
      getEvents(eventsSortOptions)
      getBusinessUnits()
      getCategories({ type: 1 })
    }
    return () => {
      resetEventsSelection()
      setEventsSortOptions({ o: "order", od: "asc" })
    }
  }, [])

  useEffect(() => {
    if (vendorId) {
      getClientConfig({ vendor_id: vendorId })
    }
  }, [vendorId])

  const handleCheckAllItems = checkboxValue => {
    selectAllEvents(checkboxValue)
  }

  const [selectedEvent, setSelectedEvent] = useState()
  const publishChangeHandler = (field, newValue) => {
    if (newValue) {
      setSelectedEvent({
        ...field,
        published: newValue,
      })
      openPublishNotificationModal()
    } else {
      changeEventPublishField({
        data: {
          ...field,
          published: newValue,
          send_published_notification: false,
        },
        type: "list",
      })
    }
  }

  const handlePublishWithoutNotification = () => {
    changeEventPublishField({
      data: {
        ...selectedEvent,
        send_published_notification: false,
      },
      type: "list",
    })
  }

  const handlePublishWithNotification = () => {
    changeEventPublishField({
      data: {
        ...selectedEvent,
        send_published_notification: true,
      },
      type: "list",
    })
  }

  const handleDeleteEventAction = event => {
    openDeleteEventModal()
    setSelectedEvent(event)
  }

  const onClickCloneExpAction = event => {
    openExpCloneConfirmationModal()
    setSelectedEvent(event)
  }

  const handleFilterExperiences = data => {
    let filterValues = {}
    if (!data?.business_unit_id || data?.business_unit_id === "view_all") {
    } else if (data?.business_unit_id === "global") {
      filterValues = { ...filterValues, hide_for_business_unit: 1 }
    } else {
      filterValues = {
        ...filterValues,
        business_unit_id: data?.business_unit_id,
      }
    }
    if (data?.active) {
      filterValues = { ...filterValues, hide_inactive_events: true }
    }
    if (data?.search) {
      filterValues = { ...filterValues, s: data?.search }
    }
    getEvents({
      ...eventsSortOptions,
      ...filterValues,
    })
    handleCheckAllItems(false)
    setRowSelection({})
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Experiences" />
        <Container fluid>
          <HeaderLine
            onSubmit={values => handleFilterExperiences(values)}
            resetSelectedEvents={() => setRowSelection({})}
          />
          <Card className="mt-3">
            <CardBody className="pt-2 px-2">
              <Row className="justify-content-between mb-2">
                <Col xs="auto">
                  <ActionsDropdown
                    fullWidth={true}
                    label={"Bulk actions"}
                    actionsList={bulkActions}
                    menuPosition={"start"}
                    color="success"
                  />
                </Col>
                <Col xs={1} style={{ minWidth: "fit-content" }}>
                  {parseInt(vendorId) !== 1 && (
                    <Link className="col-12" to={URL_PATHS.ADD_NEW_EXPERIENCE}>
                      <AddButton fullWidth={true} content="Add Experience" />
                    </Link>
                  )}
                </Col>
              </Row>
              {clientConfig.categorize_experiences ? (
                <ExpTableWithCategories
                  tableData={tableData}
                  setTableData={setTableData}
                  rowSelection={rowSelection}
                  setRowSelection={setRowSelection}
                  publishChangeHandler={publishChangeHandler}
                  handleDeleteEventAction={handleDeleteEventAction}
                  onClickCloneExpAction={exp => onClickCloneExpAction(exp)}
                />
              ) : (
                <ExperiencesTable
                  tableData={tableData}
                  handleDeleteEventAction={handleDeleteEventAction}
                  columns={experiencesListColumns(
                    handleCheckAllItems,
                    clientConfig.categorize_experiences === 1,
                    publishChangeHandler,
                    setEventsSortOptions
                  )}
                  onClickCloneExpAction={exp => onClickCloneExpAction(exp)}
                />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>

      <ModalComponent
        title="Publish Events"
        open={bulkPublishModalIsOpen}
        onClose={() => setBulkPublishModalIsOpen(false)}
      >
        <BulkPublishModal
          handleHidePublishModal={() => setBulkPublishModalIsOpen(false)}
          selectedEvents={Object.keys(rowSelection)?.map(x => parseInt(x))}
          loading={loading}
        />
      </ModalComponent>
      <ModalComponent
        title="Unpublish Events"
        open={bulkUnpublishModalIsOpen}
        onClose={() => setBulkUnpublishModalIsOpen(false)}
      >
        <BulkUnpublishModal
          handleHideUnpublishModal={() => setBulkUnpublishModalIsOpen(false)}
          selectedEvents={Object.keys(rowSelection)?.map(x => parseInt(x))}
          loading={loading}
        />
      </ModalComponent>
      <ModalComponent
        open={errorModalIsOpen}
        onClose={hideExperiencesErrorModal}
      >
        <React.Fragment>
          <Row>
            <h6>Oops...</h6>
          </Row>
          <Row>
            <p>{errorMessage || "Error"}</p>
          </Row>
          <Row className="justify-content-end">
            <Col xs={3}>
              <SaveButton
                content="OK"
                fullWidth={true}
                onClick={hideExperiencesErrorModal}
              />
            </Col>
          </Row>
        </React.Fragment>
      </ModalComponent>
      <ModalComponent
        open={isPublishNotificationModalOpen}
        onClose={hidePublishNotificationModal}
      >
        <PublishNotificationModal
          handlePublishWithoutNotification={handlePublishWithoutNotification}
          handlePublishWithNotification={handlePublishWithNotification}
          loading={loading}
        />
      </ModalComponent>
      <ModalComponent
        title={`Delete Event "${selectedEvent?.name}"`}
        open={isDeleteEventModalOpen}
        onClose={hideDeleteEventModal}
      >
        <DeleteEventModal
          handleHideDeleteModal={hideDeleteEventModal}
          handleDeleteEvent={() => handleDeleteEvent(selectedEvent)}
          loading={loading}
        />
      </ModalComponent>
      <ModalComponent
        title="Delete Events"
        open={isEventBulkDeleteModalOpen}
        onClose={hideEventBulkDeleteModal}
      >
        <EventBulkDeleteModal
          numberOfEvents={Object.keys(rowSelection)?.length}
          handleHideEventBulkDeleteModal={hideEventBulkDeleteModal}
          handleDeleteBulkAction={() => {
            handleEventBulkDelete({
              event_ids: Object.keys(rowSelection)?.map(x => parseInt(x)),
              vendor_id: parseInt(vendorId),
            })
            setRowSelection({})
          }}
          loading={loading}
        />
      </ModalComponent>
      <ModalComponent
        title={`Clone Experience - "${selectedEvent?.name}"`}
        open={cloneExpModalIsOpen}
        onClose={hideExpCloneConfirmationModal}
      >
        <CloneExperienceModal
          handleHideCloneModal={hideExpCloneConfirmationModal}
          handleCloneExperience={() =>
            cloneExperience({ data: { id: selectedEvent?.id }, history })
          }
          loading={loading}
        />
      </ModalComponent>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  events: state.experiences.events,
  categories: state.Categories.categories,
  businessUnits: state.businessUnits.businessUnits || [],
  clientConfig: state.Login.clientConfig,
  selectedEvents: state.experiences.selectedEvents,
  eventsSortOptions: state.experiences.eventsSortOptions,
  vendorId: state.Login.vendorId,
  authUser: state.Login.authUser,
  errorMessage: state.experiences.errorMessage,
  errorModalIsOpen: state.experiences.errorModalIsOpen,
  isPublishNotificationModalOpen:
    state.experiences.isPublishNotificationModalOpen,
  isDeleteEventModalOpen: state.experiences.isDeleteEventModalOpen,
  isEventBulkDeleteModalOpen: state.experiences.isEventBulkDeleteModalOpen,
  cloneExpModalIsOpen: state.experiences.cloneExpModalIsOpen,
  loading: state.experiences.loading,
})

const mapDispatchToProps = dispatch => ({
  getEvents: values => dispatch(getEvents(values)),
  getCategories: values => dispatch(getCategories(values)),
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  selectEvent: (experience, isSelected) =>
    dispatch(selectEvent(experience, isSelected)),
  selectAllEvents: isSelected => dispatch(selectAllEvents(isSelected)),
  resetEventsSelection: () => dispatch(resetEventsSelection()),
  setEventsSortOptions: sortOptions =>
    dispatch(setEventsSortOptions(sortOptions)),
  changeEventPublishField: value => dispatch(changeEventPublishField(value)),
  openPublishNotificationModal: () => dispatch(openPublishNotificationModal()),
  openDeleteEventModal: () => dispatch(openDeleteEventModal()),
  handleDeleteEvent: event => dispatch(handleDeleteEvent(event)),
  openEventBulkDeleteModal: () => dispatch(openEventBulkDeleteModal()),
  handleEventBulkDelete: events => dispatch(handleEventBulkDelete(events)),
  getClientConfig: values => dispatch(getClientConfig(values)),
  hideExperiencesErrorModal: () => dispatch(hideExperiencesErrorModal()),

  hidePublishNotificationModal: () => dispatch(hidePublishNotificationModal()),
  hideDeleteEventModal: () => dispatch(hideDeleteEventModal()),
  hideEventBulkDeleteModal: () => dispatch(hideEventBulkDeleteModal()),
  openExpCloneConfirmationModal: () =>
    dispatch(openExpCloneConfirmationModal()),
  hideExpCloneConfirmationModal: () =>
    dispatch(hideExpCloneConfirmationModal()),
  cloneExperience: values => dispatch(cloneExperience(values)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Experiences))
